import { render, staticRenderFns } from "./MenuLateralCentralReservas.vue?vue&type=template&id=d245840a&scoped=true"
import script from "./MenuLateralCentralReservas.vue?vue&type=script&lang=js"
export * from "./MenuLateralCentralReservas.vue?vue&type=script&lang=js"
import style0 from "./MenuLateralCentralReservas.vue?vue&type=style&index=0&id=d245840a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d245840a",
  null
  
)

export default component.exports